import { use_effect } from '@/hooks/_base/use_effect';
import { useState } from 'react';
import { EScreenZone } from '../e_screen_zone';

interface MousePosition {
  x: number;
  y: number;
  zone: EScreenZone;
}

export function use_mouse_position_tracker() {
  const [mouse_position, set_mouse_position] = useState<MousePosition>({
    x: 0,
    y: 0,
    zone: EScreenZone.TOP,
  });

  /*
   * EFFECTS
   */

  use_effect(() => {
    window.addEventListener('mousemove', update_mouse_position);

    return () => window.removeEventListener('mousemove', update_mouse_position);
  }, []);

  /*
   * METHODS
   */

  function update_mouse_position(e: MouseEvent) {
    const screen_height = window.innerHeight;
    const middle_line = screen_height / 2;

    const position_new: MousePosition = {
      x: e.clientX,
      y: e.clientY,
      zone: e.clientY < middle_line ? EScreenZone.TOP : EScreenZone.BOTTOM,
    };

    set_mouse_position(position_new);
  }

  return { mouse_position };
}
